// Shrinks a node's lastOutput.shape before it is persisted on the workflow
// state. The shape exists so the variable picker can show field STRUCTURE
// after a reload — it is never real data — but the server-provided shape keeps
// full arrays and 8,000-char strings, so a few data-heavy nodes pushed every
// Save/Publish toward the 15MB body cap (and past the localStorage quota).
//
// Rules:
// - Arrays keep the first few items; a marker string notes what was dropped.
// - String leaves are clipped hard (structure needs far less than 8,000 chars).
// - If the result still serializes over MAX_SHAPE_CHARS, return null — the
//   caller skips persisting, same convention as the server's 1MB guard.
//
// IMPORTANT: every marker embeds SHAPE_TRUNCATION_MARKER ("…[truncated]").
// setVariableRuntime.isTruncatedShapeValue() scans for that exact marker to
// stop clipped previews from being baked into variable values — a different
// marker here would silently corrupt variables with shortened arrays.

var SHAPE_TRUNCATION_MARKER = '…[truncated]';

var MAX_SHAPE_STRING_CHARS = 500;
var MAX_ARRAY_SAMPLE_ITEMS = 3;   // top-level arrays
var MAX_NESTED_ARRAY_ITEMS = 1;   // arrays nested deeper
var MAX_SHAPE_CHARS = 16 * 1024;  // total serialized cap per node
var MAX_DEPTH = 10;

function shrinkValue(value, depth) {
  if (value === null || value === undefined) return value;
  var t = typeof value;
  if (t === 'string') {
    if (value.length <= MAX_SHAPE_STRING_CHARS) return value;
    return value.slice(0, MAX_SHAPE_STRING_CHARS) + SHAPE_TRUNCATION_MARKER;
  }
  if (t !== 'object') return value;
  if (depth >= MAX_DEPTH) return SHAPE_TRUNCATION_MARKER;

  if (Array.isArray(value)) {
    var keep = depth === 0 ? MAX_ARRAY_SAMPLE_ITEMS : MAX_NESTED_ARRAY_ITEMS;
    var out = [];
    for (var i = 0; i < value.length && i < keep; i += 1) {
      out.push(shrinkValue(value[i], depth + 1));
    }
    if (value.length > keep) {
      out.push('… ' + (value.length - keep) + ' more items ' + SHAPE_TRUNCATION_MARKER);
    }
    return out;
  }

  var obj = {};
  var keys = Object.keys(value);
  for (var k = 0; k < keys.length; k += 1) {
    obj[keys[k]] = shrinkValue(value[keys[k]], depth + 1);
  }
  return obj;
}

// Returns the shrunk shape, or null when even the shrunk version is too big
// to be worth persisting (caller should skip the lastOutput write).
function shrinkShapeForPersistence(shape) {
  if (shape === null || shape === undefined) return shape;
  var shrunk = shrinkValue(shape, 0);
  try {
    if (JSON.stringify(shrunk).length > MAX_SHAPE_CHARS) return null;
  } catch (e) {
    return null;
  }
  return shrunk;
}

module.exports = {
  shrinkShapeForPersistence: shrinkShapeForPersistence,
  MAX_SHAPE_CHARS: MAX_SHAPE_CHARS
};
